// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Student / guest landing tokens on :root so portaled hero can use them */

:root {
  --sh-bg: #fbfbfd;
  --sh-ink: #1f1b2e;
  --sh-muted: #55515f;
  --sh-pink: #f2c4c4;
  --sh-peach: #f9e1be;
  --sh-mint: #bff1db;
  --sh-lavender: #d5d1fd;
  --sh-panel: #f4f2f8;
  --sh-surface: #ffffff;
  --sh-line: rgba(31, 27, 46, 0.1);
  --sh-radius: 20px;
  --sh-radius-sm: 14px;
  /* ~5% breathing room on each side */
  --sh-section-x: 5%;
  --sh-section-y: clamp(3rem, 7vh, 5.5rem);
  --sh-max: 100%;
  --hero-progress: 0;
  --hero-scale: 1.02;
  --hero-content-opacity: 1;
  --hero-content-scale: 1;
  --hero-blur: 0px;
}

.student-landing {
  background: var(--sh-bg);
  color: var(--sh-ink);
}

/* Kill rubber-band bounce when the content sheet is active */
body.student-landing-mode-content {
  overscroll-behavior-y: none;
}

body.student-landing-mode-content .student-hero-stage {
  height: 0 !important;
  min-height: 0 !important;
  max-height: 0 !important;
  overflow: hidden;
}

/* â€”â€” Navbar: submerged in hero, solidifies on scroll â€”â€” */
.student-landing .student-nav-spacer {
  margin-bottom: 0;
  height: 0;
}

.student-landing .student-nav {
  z-index: 50;
  height: 72px;
  border-bottom: 1px solid transparent;
  box-shadow: none;
  transition:
    background-color 0.35s ease,
    border-color 0.35s ease,
    box-shadow 0.35s ease,
    backdrop-filter 0.35s ease;
}

.student-landing .student-nav--overlay {
  top: 0.9rem;
  background-color: transparent !important;
  backdrop-filter: none;
  -webkit-backdrop-filter: none;
}

.student-landing .student-nav--solid {
  background-color: var(--sh-bg) !important;
  backdrop-filter: none;
  -webkit-backdrop-filter: none;
  border-bottom-color: rgba(48, 45, 69, 0.08);
  box-shadow: 0 8px 28px rgba(48, 45, 69, 0.08);
}

.student-landing .student-nav .navbar-brand {
  padding: 0;
}

.student-landing .student-nav .student-nav__logo {
  margin-left: clamp(0.75rem, 2vw, 1.5rem);
  height: 34px;
  width: auto;
  display: block;
  transition: filter 0.35s ease, opacity 0.35s ease;
}

.student-landing .student-nav--overlay .student-nav__logo {
  filter: brightness(0) invert(1);
}

.student-landing .student-nav--solid .student-nav__logo {
  filter: none;
}

.student-landing .student-nav .navbar-toggler {
  margin-right: 0.75rem;
  border-radius: 12px !important;
  padding: 0.4rem 0.55rem;
  transition:
    background-color 0.3s ease,
    border-color 0.3s ease,
    filter 0.3s ease;
}

.student-landing .student-nav--overlay .navbar-toggler {
  background: #fff !important;
  border: none !important;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.22);
}

.student-landing .student-nav--overlay .navbar-toggler-icon {
  filter: none;
}

.student-landing .student-nav .navbar-collapse {
  margin-right: clamp(0.5rem, 2vw, 1.5rem);
}

.student-landing .student-nav .navbar-nav {
  align-items: center;
  gap: 0.45rem;
  padding: 0.75rem 0;
}

.student-landing .student-nav--overlay .navbar-nav {
  gap: 0.55rem;
}

@media (max-width: 991.98px) {
  .student-landing .student-nav .navbar-collapse {
    background: var(--sh-bg);
    margin: 0.5rem 0.75rem 0;
    padding: 0.75rem 1rem 1rem;
    border-radius: var(--sh-radius-sm);
    border: 1px solid rgba(48, 45, 69, 0.08);
    box-shadow: 0 10px 28px rgba(48, 45, 69, 0.12);
  }

  .student-landing .student-nav--overlay .navbar-collapse {
    background: rgba(18, 16, 26, 0.9);
    border-color: rgba(255, 255, 255, 0.12);
    box-shadow: 0 14px 36px rgba(0, 0, 0, 0.35);
    backdrop-filter: blur(16px);
    -webkit-backdrop-filter: blur(16px);
  }

  .student-landing .student-nav .navbar-nav {
    align-items: stretch;
  }

  .student-landing .student-nav .nav-item,
  .student-landing .student-nav .dropdown {
    width: 100%;
  }

  .student-landing .student-nav .btn {
    width: 100%;
    margin: 0.25rem 0 !important;
  }
}

@media (min-width: 992px) {
  .student-landing .student-nav .navbar-nav {
    padding: 0;
  }
}

.student-landing .student-nav .btn {
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
  line-height: 1.2;
  border-radius: 999px !important;
  font-weight: 700 !important;
  font-size: 0.85rem !important;
  padding: 0.45rem 1.1rem !important;
  color: var(--sh-ink) !important;
  box-shadow: none;
  text-decoration: none !important;
  transition:
    transform 0.15s ease,
    filter 0.15s ease,
    box-shadow 0.3s ease,
    background-color 0.3s ease,
    border-color 0.3s ease,
    color 0.3s ease;
}

/* Hero overlay only: same white chips, labels easier to read at a glance */
.student-landing .student-nav--overlay .btn {
  min-height: 3.15rem;
  padding: 0.7rem 1.65rem !important;
  font-size: 1.18rem !important;
  font-weight: 800 !important;
  letter-spacing: 0.06em;
  line-height: 1.15 !important;
  text-transform: uppercase;
  background: #fff !important;
  border: none !important;
  color: #14121c !important;
  box-shadow: 0 10px 28px rgba(0, 0, 0, 0.3);
}

.student-landing .student-nav--overlay .btn:hover {
  background: #fff !important;
  color: #14121c !important;
  filter: none;
  transform: translateY(-2px);
  box-shadow: 0 14px 34px rgba(0, 0, 0, 0.36);
}

@media (min-width: 992px) {
  .student-landing .student-nav--overlay {
    top: 1.1rem;
  }

  .student-landing .student-nav--overlay .navbar-nav {
    gap: 0.75rem;
  }

  .student-landing .student-nav--overlay .btn {
    font-size: 1.22rem !important;
  }
}

.student-landing .student-nav--solid .btn:hover {
  filter: brightness(0.97);
  transform: translateY(-1px);
}

/* â€”â€” Immersive full-viewport hero â€”â€” */
/* Stage = document spacer only. Hero paints fixed over the real viewport. */
.student-hero-stage {
  width: 100%;
  height: 100vh;
  height: 100svh;
  height: 100dvh;
  pointer-events: none;
}

.student-hero {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  height: 100dvh;
  /* Above body at rest so spacer mismatch never reveals white content.
     Drops under the content sheet once the user starts scrolling. */
  z-index: 3;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  overflow: hidden;
  color: #fff;
  /* Dimmed teal matching the photo so there's no flash before it loads */
  background-color: #4f6f78;
  /* Do not transform this layer â€” transforms break fixed viewport coverage */
}

body.student-landing-scrolled .student-hero {
  z-index: 1;
}

body.student-landing-hero-done .student-hero,
body.student-landing-mode-content .student-hero {
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
}

body.student-landing-mode-hero .student-hero {
  opacity: 1;
  visibility: visible;
  pointer-events: auto;
  z-index: 3;
  transition: opacity 0.28s ease, visibility 0.28s ease;
}

/* Explore → content: keep hero visible while progress/blur/stage animate */
body.student-landing-hero-exiting .student-hero {
  opacity: calc(1 - var(--hero-progress) * 1.05);
  visibility: visible;
  pointer-events: none;
  z-index: 3;
  transition: none;
}

body.student-landing-hero-exiting .student-hero__media {
  transition: none;
}

body.student-landing-hero-exiting .student-landing__body {
  animation: student-content-rise 0.78s cubic-bezier(0.22, 1, 0.36, 1) both;
}

@keyframes student-content-rise {
  from {
    opacity: 0.35;
    transform: translateY(28px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@media (prefers-reduced-motion: reduce) {
  body.student-landing-hero-exiting .student-landing__body {
    animation: none;
  }
}

.student-hero__media {
  position: absolute;
  inset: -1.5%;
  z-index: 0;
  overflow: hidden;
  /* Cursor parallax (set by MainImageHeader) + scroll scale */
  transform: translate3d(var(--hero-mx, 0px), var(--hero-my, 0px), 0)
    scale(var(--hero-scale));
  transform-origin: center center;
  filter: blur(var(--hero-blur));
  will-change: transform, filter;
  pointer-events: none;
  transition: transform 0.9s cubic-bezier(0.2, 0.8, 0.2, 1);
}

.student-hero__art {
  position: absolute;
  inset: 0;
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center center;
  -webkit-user-select: none;
          user-select: none;
  /* Original brand art ran at brightness(30%); keep the scene readable
     but dim enough for white headline copy. */
  filter: brightness(0.56) saturate(1.08);
  /* Slow cinematic drift â€” Ken Burns (kept subtle so the full scene stays in frame) */
  transform-origin: 50% 55%;
  animation:
    student-hero-art-in 1.6s cubic-bezier(0.22, 1, 0.36, 1) both,
    student-hero-kenburns 28s ease-in-out 1.2s infinite alternate;
  will-change: transform;
}

@keyframes student-hero-art-in {
  from {
    opacity: 0;
    transform: scale(1.06);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

@keyframes student-hero-kenburns {
  0% {
    transform: scale(1) translate3d(0, 0, 0);
  }
  100% {
    transform: scale(1.055) translate3d(-0.6%, 0.5%, 0);
  }
}

/* Ambient pastel particles drifting upward */
.student-hero__particles {
  position: absolute;
  inset: 0;
  z-index: 1;
  overflow: hidden;
  pointer-events: none;
}

.student-hero__particle {
  position: absolute;
  left: var(--px);
  top: var(--py);
  width: var(--ps);
  height: var(--ps);
  border-radius: 50%;
  opacity: 0;
  filter: blur(0.6px);
  animation: student-hero-particle var(--pt) linear var(--pd) infinite;
  will-change: transform, opacity;
}

.student-hero__particle--mint {
  background: #bff1db;
  box-shadow: 0 0 14px 2px rgba(191, 241, 219, 0.55);
}
.student-hero__particle--lavender {
  background: #d5d1fd;
  box-shadow: 0 0 14px 2px rgba(213, 209, 253, 0.55);
}
.student-hero__particle--peach {
  background: #f9e1be;
  box-shadow: 0 0 14px 2px rgba(249, 225, 190, 0.5);
}
.student-hero__particle--pink {
  background: #f2c4c4;
  box-shadow: 0 0 14px 2px rgba(242, 196, 196, 0.5);
}

@keyframes student-hero-particle {
  0% {
    transform: translate3d(0, 0, 0) scale(0.6);
    opacity: 0;
  }
  12% {
    opacity: 0.55;
  }
  50% {
    transform: translate3d(14px, -45vh, 0) scale(1);
    opacity: 0.7;
  }
  88% {
    opacity: 0.35;
  }
  100% {
    transform: translate3d(-10px, -92vh, 0) scale(0.7);
    opacity: 0;
  }
}

.student-hero__overlay {
  position: absolute;
  inset: 0;
  z-index: 1;
  background:
    radial-gradient(
      ellipse 70% 60% at 50% 48%,
      rgba(10, 18, 26, 0.42) 0%,
      rgba(10, 18, 26, 0.12) 60%,
      rgba(10, 18, 26, 0) 100%
    ),
    linear-gradient(
      180deg,
      rgba(10, 18, 26, 0.3) 0%,
      rgba(10, 18, 26, 0.08) 45%,
      rgba(10, 18, 26, 0.42) 100%
    );
  pointer-events: none;
}

.student-hero__content {
  position: relative;
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: min(100%, 920px);
  padding: clamp(5rem, 14vh, 8rem) var(--sh-section-x)
    clamp(6rem, 14vh, 8rem);
  pointer-events: auto;
  opacity: var(--hero-content-opacity);
  /* Counter-parallax against the image for depth */
  transform: translate3d(
      calc(var(--hero-mx, 0px) * -0.35),
      calc(var(--hero-progress) * -6vh + var(--hero-my, 0px) * -0.35),
      0
    )
    scale(var(--hero-content-scale));
  transform-origin: center center;
  will-change: transform, opacity;
  transition: transform 0.9s cubic-bezier(0.2, 0.8, 0.2, 1);
}

.student-hero__brand {
  margin: 0;
  font-weight: 800;
  font-size: clamp(2.55rem, 8.5vw, 5rem);
  letter-spacing: 0.045em;
  line-height: 1.02;
  text-transform: uppercase;
  text-shadow: 0 10px 40px rgba(0, 0, 0, 0.35);
  opacity: 0;
  /* Cinematic tracking-in entrance */
  animation: student-hero-brand-in 1.2s cubic-bezier(0.22, 1, 0.36, 1) 0.2s
    forwards;
}

@keyframes student-hero-brand-in {
  0% {
    opacity: 0;
    letter-spacing: 0.22em;
    transform: translateY(26px);
    filter: blur(6px);
  }
  60% {
    filter: blur(0);
  }
  100% {
    opacity: 1;
    letter-spacing: 0.045em;
    transform: translateY(0);
    filter: blur(0);
  }
}

.student-hero__headline {
  margin: 0.4rem 0 0;
  font-weight: 700;
  font-size: clamp(1.35rem, 4.2vw, 2.4rem);
  letter-spacing: 0.1em;
  line-height: 1.15;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.94);
  text-shadow: 0 8px 30px rgba(0, 0, 0, 0.3);
  opacity: 0;
  animation: student-hero-fade-up 0.85s cubic-bezier(0.22, 1, 0.36, 1) 0.28s
    forwards;
}

.student-hero__tagline {
  position: relative;
  margin: clamp(1rem, 2.5vh, 1.5rem) 0 0;
  padding-bottom: 0.85rem;
  font-weight: 600;
  font-size: clamp(0.95rem, 2.2vw, 1.2rem);
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.8);
  opacity: 0;
  animation: student-hero-fade-up 0.85s cubic-bezier(0.22, 1, 0.36, 1) 0.5s
    forwards;
}

/* Accent rule draws in beneath the tagline */
.student-hero__tagline::after {
  content: "";
  position: absolute;
  left: 50%;
  bottom: 0;
  width: 64px;
  height: 2px;
  border-radius: 2px;
  background: linear-gradient(90deg, #bff1db, #d5d1fd);
  transform: translateX(-50%) scaleX(0);
  transform-origin: center;
  animation: student-hero-rule-in 0.9s cubic-bezier(0.22, 1, 0.36, 1) 1.05s
    forwards;
}

@keyframes student-hero-rule-in {
  to {
    transform: translateX(-50%) scaleX(1);
  }
}

.student-hero__cta {
  position: relative;
  isolation: isolate;
  margin-top: clamp(1.5rem, 3.5vh, 2.1rem);
  display: inline-flex;
  align-items: center;
  gap: 0.65rem;
  padding: 0.9rem 2rem;
  background-color: #bff1db !important;
  color: #1f1b2e !important;
  border: none !important;
  border-radius: 999px !important;
  cursor: pointer;
  font-size: clamp(1rem, 2vw, 1.2rem);
  font-weight: 800 !important;
  text-decoration: none;
  box-shadow: 0 12px 36px rgba(0, 0, 0, 0.28);
  transition: transform 0.18s ease, filter 0.18s ease, box-shadow 0.18s ease;
  opacity: 0;
  animation: student-hero-fade-up 0.85s cubic-bezier(0.22, 1, 0.36, 1) 0.7s
    forwards;
}

/* Soft expanding pulse ring behind the CTA */
.student-hero__cta::before {
  content: "";
  position: absolute;
  inset: 0;
  z-index: -1;
  border-radius: inherit;
  background: rgba(191, 241, 219, 0.55);
  animation: student-hero-pulse 3.2s cubic-bezier(0.2, 0.6, 0.3, 1) 1.8s
    infinite;
  pointer-events: none;
}

@keyframes student-hero-pulse {
  0% {
    transform: scale(1);
    opacity: 0.6;
  }
  55%,
  100% {
    transform: scale(1.32, 1.6);
    opacity: 0;
  }
}

.student-hero__cta:hover {
  filter: brightness(1.03);
  transform: translateY(-2px);
  box-shadow: 0 16px 40px rgba(0, 0, 0, 0.32);
  color: var(--sh-ink) !important;
}

.student-hero__cta:active {
  transform: translateY(0);
}

.student-hero__scroll {
  /* Center without translateX â€” avoids jump when global :active scale fires */
  position: absolute;
  left: 0;
  right: 0;
  bottom: clamp(1.25rem, 3.5vh, 2.25rem);
  z-index: 3;
  width: max-content;
  margin-left: auto;
  margin-right: auto;
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  gap: 0.55rem;
  padding: 0.55rem 1rem;
  border: none !important;
  background: transparent !important;
  color: #fff !important;
  font-size: 0.92rem !important;
  font-weight: 800 !important;
  letter-spacing: 0.2em;
  text-transform: uppercase;
  cursor: pointer;
  pointer-events: auto;
  border-radius: 0 !important;
  opacity: calc(var(--hero-content-opacity) * 0.95);
  text-shadow: 0 2px 14px rgba(0, 0, 0, 0.45);
  transition: opacity 0.2s ease;
}

.student-hero__scroll:active {
  transform: none !important;
  box-shadow: none !important;
}

.student-hero__scroll-label {
  color: #fff !important;
  font-size: 1rem;
  font-weight: 800;
  letter-spacing: 0.2em;
}

.student-hero__scroll-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2.75rem;
  height: 2.75rem;
  border: 1.75px solid rgba(255, 255, 255, 0.65);
  border-radius: 999px;
  color: #fff !important;
  font-size: 1.15rem;
  animation: student-hero-bounce 1.6s ease-in-out infinite;
}

.student-hero__scroll:hover,
.student-hero__scroll:hover .student-hero__scroll-label,
.student-hero__scroll:hover .student-hero__scroll-icon {
  color: #fff !important;
  opacity: 1;
}

@keyframes student-hero-fade-up {
  from {
    opacity: 0;
    transform: translateY(22px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes student-hero-bounce {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(8px);
  }
}

/* Content sheet scrolls over the fixed hero */
.student-landing__body {
  position: relative;
  z-index: 2;
  background: var(--sh-bg);
  border-radius: 28px 28px 0 0;
  box-shadow: 0 -20px 50px rgba(20, 16, 32, 0.14);
  margin-top: 0;
  padding-top: calc(72px + 1rem);
  overflow-x: clip;
  overflow-y: visible;
}

/* —— Scroll reveal —— */
.student-reveal .student-section__eyebrow,
.student-reveal .student-section__title,
.student-reveal .student-section__lede,
.student-reveal .student-about__copy,
.student-reveal .student-controls__card,
.student-reveal .student-offerings__card,
.student-reveal .student-about__pillar,
.student-reveal .student-contact__item,
.student-reveal .student-schedule__track {
  opacity: 0;
  transform: translateY(28px);
  transition:
    opacity 0.7s cubic-bezier(0.22, 1, 0.36, 1),
    transform 0.7s cubic-bezier(0.22, 1, 0.36, 1);
}

.student-reveal.is-inview .student-section__eyebrow,
.student-reveal.is-inview .student-section__title,
.student-reveal.is-inview .student-section__lede,
.student-reveal.is-inview .student-about__copy,
.student-reveal.is-inview .student-controls__card,
.student-reveal.is-inview .student-offerings__card,
.student-reveal.is-inview .student-about__pillar,
.student-reveal.is-inview .student-contact__item,
.student-reveal.is-inview .student-schedule__track {
  opacity: 1;
  transform: translateY(0);
}

/* Header cascade */
.student-reveal.is-inview .student-section__eyebrow {
  transition-delay: 0.05s;
}
.student-reveal.is-inview .student-section__title {
  transition-delay: 0.12s;
}
.student-reveal.is-inview .student-section__lede,
.student-reveal.is-inview .student-about__copy {
  transition-delay: 0.2s;
}

/* Card / pillar stagger */
.student-reveal.is-inview .student-controls__card:nth-child(1),
.student-reveal.is-inview .student-offerings__card:nth-child(1),
.student-reveal.is-inview .student-about__pillar:nth-child(1),
.student-reveal.is-inview .student-contact__item:nth-child(1) {
  transition-delay: 0.18s;
}
.student-reveal.is-inview .student-controls__card:nth-child(2),
.student-reveal.is-inview .student-offerings__card:nth-child(2),
.student-reveal.is-inview .student-about__pillar:nth-child(2),
.student-reveal.is-inview .student-contact__item:nth-child(2) {
  transition-delay: 0.28s;
}
.student-reveal.is-inview .student-controls__card:nth-child(3),
.student-reveal.is-inview .student-offerings__card:nth-child(3),
.student-reveal.is-inview .student-about__pillar:nth-child(3),
.student-reveal.is-inview .student-contact__item:nth-child(3) {
  transition-delay: 0.38s;
}
.student-reveal.is-inview .student-controls__card:nth-child(4),
.student-reveal.is-inview .student-offerings__card:nth-child(4),
.student-reveal.is-inview .student-contact__item:nth-child(4) {
  transition-delay: 0.48s;
}
.student-reveal.is-inview .student-controls__card:nth-child(n + 5),
.student-reveal.is-inview .student-offerings__card:nth-child(n + 5) {
  transition-delay: 0.56s;
}

.student-reveal.is-inview .student-schedule__track {
  transition-delay: 0.22s;
}

@media (prefers-reduced-motion: reduce) {
  .student-hero__media,
  .student-hero__content {
    filter: none !important;
    transform: none !important;
    transition: none !important;
  }

  .student-hero__art {
    animation: none !important;
    transform: none !important;
  }

  .student-hero__particles {
    display: none !important;
  }

  .student-hero__brand,
  .student-hero__headline,
  .student-hero__tagline,
  .student-hero__cta,
  .student-hero__scroll-icon {
    animation: none !important;
    opacity: 1;
    transform: none !important;
    filter: none !important;
  }

  .student-hero__tagline::after {
    animation: none !important;
    transform: translateX(-50%) scaleX(1) !important;
  }

  .student-hero__cta::before {
    display: none !important;
  }

  .student-reveal,
  .student-reveal .student-section__eyebrow,
  .student-reveal .student-section__title,
  .student-reveal .student-section__lede,
  .student-reveal .student-about__copy,
  .student-reveal .student-controls__card,
  .student-reveal .student-offerings__card,
  .student-reveal .student-about__pillar,
  .student-reveal .student-contact__item,
  .student-reveal .student-schedule__track {
    opacity: 1 !important;
    transform: none !important;
    transition: none !important;
  }

  .student-section__title::after {
    transform: scaleX(1) !important;
    transition: none !important;
  }
}

/* —— Shared section shell —— */
.student-section {
  width: 100%;
  padding: var(--sh-section-y) var(--sh-section-x);
}

.student-section__inner {
  width: var(--sh-max);
  max-width: 100%;
  margin: 0 auto;
}

.student-section__header {
  margin-bottom: clamp(1.5rem, 3vw, 2.25rem);
  max-width: 40rem;
}

.student-section__header--center {
  margin-left: auto;
  margin-right: auto;
  text-align: center;
  max-width: 28rem;
}

.student-section__eyebrow {
  margin: 0 0 0.45rem;
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: var(--sh-muted);
}

.student-section__title {
  position: relative;
  margin: 0;
  padding-bottom: 0.75rem;
  font-weight: 800;
  font-size: clamp(1.75rem, 3.4vw, 2.35rem);
  letter-spacing: -0.01em;
  line-height: 1.15;
  color: var(--sh-ink);
  text-transform: none;
}

.student-section__header--center .student-section__title {
  display: inline-block;
}

.student-section__title::after {
  content: "";
  position: absolute;
  left: 0;
  bottom: 0;
  width: 2.75rem;
  height: 2px;
  background: var(--sh-ink);
  transform: scaleX(0);
  transform-origin: left center;
  transition: transform 0.7s cubic-bezier(0.22, 1, 0.36, 1) 0.2s;
}

.student-section__header--center .student-section__title::after {
  left: 50%;
  transform: translateX(-50%) scaleX(0);
  transform-origin: center;
}

.student-reveal.is-inview .student-section__title::after {
  transform: scaleX(1);
}

.student-reveal.is-inview .student-section__header--center .student-section__title::after {
  transform: translateX(-50%) scaleX(1);
}

.student-section__lede {
  margin: 0.9rem 0 0;
  font-size: clamp(0.98rem, 1.5vw, 1.08rem);
  line-height: 1.55;
  color: var(--sh-muted);
  font-weight: 500;
}

/* —— Quick controls —— */
.student-controls {
  padding-top: clamp(1.75rem, 4vh, 2.75rem);
  padding-bottom: clamp(1rem, 3vh, 1.75rem);
}

.student-controls__grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: clamp(0.85rem, 1.8vw, 1.25rem);
}

.student-controls__card {
  --control-accent: #d5d1fd;
  position: relative;
  overflow: hidden;
  display: grid;
  grid-template-columns: auto 1fr auto;
  align-items: center;
  gap: 0.9rem;
  width: 100%;
  min-height: 6.5rem;
  padding: 1.15rem 1.1rem 1.15rem 1.25rem;
  border: 1px solid var(--sh-line) !important;
  border-radius: var(--sh-radius) !important;
  background: var(--sh-surface) !important;
  box-shadow: 0 8px 22px rgba(48, 45, 69, 0.05);
  cursor: pointer;
  text-align: left;
  color: var(--sh-ink) !important;
  transition:
    transform 0.28s cubic-bezier(0.22, 1, 0.36, 1),
    box-shadow 0.28s cubic-bezier(0.22, 1, 0.36, 1),
    border-color 0.28s ease;
}

.student-controls__card::after {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 4px;
  background: var(--control-accent);
}

.student-reveal.is-inview .student-controls__card:hover {
  transform: translateY(-4px);
  border-color: rgba(31, 27, 46, 0.16) !important;
  box-shadow: 0 16px 34px rgba(48, 45, 69, 0.1);
}

.student-controls__card:focus-visible {
  outline: 2px solid var(--sh-ink);
  outline-offset: 3px;
}

.student-controls__icon-wrap {
  display: grid;
  place-items: center;
  width: 2.85rem;
  height: 2.85rem;
  border-radius: 14px;
  background: var(--control-accent);
  flex-shrink: 0;
}

.student-controls__icon {
  width: 1.15rem;
  height: 1.15rem;
  color: var(--sh-ink);
}

.student-controls__text {
  display: flex;
  flex-direction: column;
  gap: 0.28rem;
  min-width: 0;
}

.student-controls__label {
  margin: 0;
  font-size: 0.86rem;
  font-weight: 800;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--sh-ink);
}

.student-controls__blurb {
  font-size: 0.82rem;
  line-height: 1.4;
  font-weight: 500;
  color: var(--sh-muted);
}

.student-controls__go {
  display: grid;
  place-items: center;
  width: 1.75rem;
  height: 1.75rem;
  border-radius: 999px;
  color: var(--sh-ink);
  opacity: 0.45;
  transition: opacity 0.2s ease, transform 0.2s ease;
}

.student-controls__card:hover .student-controls__go {
  opacity: 1;
  transform: translateX(2px);
}

@media (max-width: 1100px) {
  .student-controls__grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 560px) {
  .student-controls__grid {
    grid-template-columns: 1fr;
  }
}

/* —— Schedule —— */
.student-schedule {
  background: var(--sh-panel);
  padding-bottom: clamp(2.5rem, 6vh, 4rem);
}

.student-schedule__track {
  width: var(--sh-max);
  max-width: 100%;
  margin: 0 auto;
  box-sizing: border-box;
}

.student-schedule__track .slick-slider,
.student-schedule__track .slick-list,
.student-schedule__track .slick-track {
  width: 100%;
}

.student-landing .home-schedule-carousel__loading {
  margin: 0;
  padding: 2rem 0;
  color: var(--sh-muted);
  font-weight: 600;
}

.student-landing .home-schedule-slide {
  padding: 0 6px 8px;
}

.student-landing .home-schedule-slide__panel {
  padding: 1rem 1rem 1.1rem;
  max-height: none;
  border-radius: var(--sh-radius);
  border: 1px solid var(--sh-line);
  background: var(--sh-surface);
  box-shadow: 0 10px 28px rgba(48, 45, 69, 0.07);
  transition:
    transform 0.3s cubic-bezier(0.22, 1, 0.36, 1),
    box-shadow 0.3s cubic-bezier(0.22, 1, 0.36, 1);
}

.student-landing .home-schedule-slide:hover .home-schedule-slide__panel {
  transform: translateY(-4px);
  box-shadow: 0 16px 36px rgba(48, 45, 69, 0.11);
}

.student-landing .home-schedule-slide__header {
  gap: 0.75rem;
  padding-bottom: 0.85rem;
  margin-bottom: 0.85rem;
}

.student-landing .home-schedule-slide__photo.teacher-photo-frame--circle {
  width: 96px;
  height: 96px;
  min-width: 96px;
  min-height: 96px;
  max-width: 96px;
  max-height: 96px;
  border-width: 3px;
}

.student-landing .home-schedule-slide__name {
  font-size: clamp(1rem, 1.6vw, 1.15rem);
  letter-spacing: 0.02em;
}

/* 3-up cards are narrower — keep courses stacked */
.student-landing .home-schedule-slide__courses--split,
.student-landing .home-schedule-slide__courses--dense {
  grid-template-columns: 1fr;
  gap: 8px;
}

.student-landing .home-schedule-course {
  grid-template-columns: minmax(0, 1fr) minmax(120px, 0.9fr);
  gap: 8px 12px;
  padding: 11px 0;
}

.student-landing .home-schedule-course__title {
  font-size: 1rem;
}

.student-landing .home-schedule-course__day {
  min-width: 1.9rem;
  padding: 3px 6px;
  font-size: 0.7rem;
}

.student-landing .home-schedule-course__clock {
  font-size: 0.84rem;
}

@media (max-width: 700px) {
  .student-landing .home-schedule-slide__photo.teacher-photo-frame--circle {
    width: 84px;
    height: 84px;
    min-width: 84px;
    min-height: 84px;
    max-width: 84px;
    max-height: 84px;
  }

  .student-landing .home-schedule-course {
    grid-template-columns: 1fr;
  }
}

/* —— Offerings —— */
.student-offerings {
  background: var(--sh-bg);
}

.student-offerings__grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: clamp(1rem, 2.2vw, 1.5rem);
}

.student-offerings__card {
  display: flex;
  align-items: stretch;
  gap: 1.1rem;
  min-width: 0;
  padding: 0.85rem;
  background: var(--sh-surface);
  border: 1px solid var(--sh-line);
  border-radius: var(--sh-radius);
  box-shadow: 0 8px 24px rgba(48, 45, 69, 0.05);
  transition:
    transform 0.3s cubic-bezier(0.22, 1, 0.36, 1),
    box-shadow 0.3s cubic-bezier(0.22, 1, 0.36, 1);
}

.student-reveal.is-inview .student-offerings__card:hover {
  transform: translateY(-4px);
  box-shadow: 0 16px 36px rgba(48, 45, 69, 0.1);
}

/* Dimensions from TeacherPhoto (--portrait); keep flex hook */
.student-offerings__photo {
  flex-shrink: 0;
}

.student-offerings__body {
  display: flex;
  flex: 1 1;
  flex-direction: column;
  justify-content: center;
  gap: 0.55rem;
  min-width: 0;
  padding: 0.35rem 0.75rem 0.35rem 0;
}

.student-offerings__caption {
  margin: 0;
  font-size: calc(0.72rem + 2px);
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: var(--sh-muted);
  line-height: 1.35;
}

.student-offerings__name {
  margin: 0;
  padding-bottom: 0.55rem;
  border-bottom: 1px solid var(--sh-line);
  font-family: "Merriweather", Georgia, serif;
  font-weight: 700;
  font-size: clamp(calc(1.2rem + 2px), calc(1.9vw + 2px), calc(1.45rem + 2px));
  letter-spacing: -0.015em;
  color: var(--sh-ink);
  text-transform: none;
  line-height: 1.25;
  text-align: left;
}

.student-offerings__desc {
  margin: 0;
  font-weight: 500;
  font-size: calc(0.95rem + 2px);
  line-height: 1.5;
  color: var(--sh-muted);
  text-align: left;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.student-offerings__toggle {
  display: block;
  width: max-content;
  margin: 2rem auto 0;
  padding: 0.65rem 1.4rem;
  border: 1px solid var(--sh-line) !important;
  background: var(--sh-surface) !important;
  border-radius: 999px !important;
  font-weight: 700 !important;
  font-size: 0.9rem !important;
  color: var(--sh-ink) !important;
  cursor: pointer;
  transition:
    background-color 0.2s ease,
    border-color 0.2s ease,
    transform 0.2s ease;
}

.student-offerings__toggle:hover {
  background: var(--sh-panel) !important;
  border-color: rgba(31, 27, 46, 0.18) !important;
  transform: translateY(-1px);
}

@media (max-width: 1100px) {
  .student-offerings__grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 640px) {
  .student-offerings__grid {
    grid-template-columns: 1fr;
  }
}

/* —— About —— */
.student-about {
  background: var(--sh-panel);
}

.student-about__header {
  max-width: 52rem;
  margin-bottom: clamp(1.75rem, 4vw, 2.75rem);
}

.student-about__copy {
  margin: 1rem auto 0;
  font-size: clamp(1rem, 1.5vw, 1.08rem);
  line-height: 1.75;
  font-weight: 500;
  color: var(--sh-muted);
  text-align: left;
}

.student-section__header--center .student-about__copy {
  text-align: center;
}

.student-about__pillars {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: clamp(0.9rem, 2vw, 1.35rem);
}

.student-about__pillar {
  padding: 1.35rem 1.3rem 1.45rem;
  background: var(--sh-surface);
  border: 1px solid var(--sh-line);
  border-radius: var(--sh-radius);
  box-shadow: 0 8px 22px rgba(48, 45, 69, 0.04);
  transition: transform 0.28s cubic-bezier(0.22, 1, 0.36, 1);
}

.student-about__pillar:hover {
  transform: translateY(-3px);
}

.student-about__pillar-title {
  margin: 0;
  font-size: 1.05rem;
  font-weight: 800;
  color: var(--sh-ink);
}

.student-about__pillar-text {
  margin: 0.55rem 0 0;
  font-size: 0.92rem;
  line-height: 1.55;
  font-weight: 500;
  color: var(--sh-muted);
}

@media (max-width: 800px) {
  .student-about__pillars {
    grid-template-columns: 1fr;
  }

  .student-section__header--center .student-about__copy {
    text-align: left;
  }
}

/* —— Contact —— */
.student-contact {
  background: var(--sh-bg);
}

.student-contact__layout {
  display: grid;
  grid-template-columns: minmax(0, 0.95fr) minmax(0, 1.05fr);
  gap: clamp(1.75rem, 4vw, 3.5rem);
  align-items: stretch;
}

.student-contact__info {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.student-contact__intro {
  margin: 0.85rem 0 1.5rem;
  font-weight: 600;
  font-size: clamp(1rem, 1.6vw, 1.1rem);
  line-height: 1.5;
  color: var(--sh-muted);
}

.student-contact__list {
  display: flex;
  flex-direction: column;
  margin: 0;
  padding: 0;
  list-style: none;
  border-top: 1px solid var(--sh-line);
}

.student-contact__item {
  padding: 1.15rem 0;
  border-bottom: 1px solid var(--sh-line);
}

.student-contact__label {
  display: block;
  margin-bottom: 0.3rem;
  font-weight: 800;
  font-size: 0.75rem;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: var(--sh-ink);
}

.student-contact__value {
  margin: 0;
  font-weight: 600;
  font-size: 1.02rem;
  line-height: 1.55;
  color: var(--sh-muted);
}

.student-contact__value a {
  color: inherit;
  text-decoration: none;
  border-bottom: 1px solid transparent;
  transition: color 0.2s ease, border-color 0.2s ease;
}

.student-contact__value a:hover {
  color: var(--sh-ink);
  border-bottom-color: rgba(31, 27, 46, 0.35);
}

.student-contact__socials {
  display: flex;
  flex-wrap: wrap;
  gap: 0.65rem 1.15rem;
  margin-top: 0.15rem;
}

.student-contact__social {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  font-weight: 700;
  font-size: 0.95rem;
  color: var(--sh-muted);
  text-decoration: none;
  transition: color 0.2s ease, transform 0.15s ease;
}

.student-contact__social svg {
  width: 1.05rem;
  height: 1.05rem;
  flex-shrink: 0;
}

.student-contact__social:hover {
  color: var(--sh-ink);
  transform: translateY(-1px);
}

.student-contact__map {
  width: 100%;
  min-height: 420px;
  height: 100%;
  border: 0;
  border-radius: var(--sh-radius);
  background: #eceaf0;
  box-shadow: 0 12px 32px rgba(48, 45, 69, 0.08);
  border: 1px solid var(--sh-line);
}

@media (max-width: 860px) {
  .student-contact__layout {
    grid-template-columns: 1fr;
  }

  .student-contact__map {
    min-height: 320px;
    height: 320px;
  }
}

/* —— Footer —— */
.student-landing .student-footer {
  position: relative;
  background: #1f1b2e;
  color: rgba(255, 255, 255, 0.82);
  text-align: center;
  height: auto;
  min-height: 4.25rem;
  font-size: 0.85rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0;
  margin-top: 0;
  padding: 1.35rem var(--sh-section-x);
  opacity: 1;
  visibility: visible;
}

.student-landing .student-footer p {
  margin: 0;
}

/* —— Narrow phones —— */
@media (max-width: 480px) {
  .student-hero {
    min-height: min(78vh, 640px);
  }

  .student-hero__content {
    padding-top: 4.75rem;
    padding-bottom: 3.25rem;
  }

  .student-hero__cta {
    width: 100%;
    max-width: 280px;
    justify-content: center;
  }
}
`, "",{"version":3,"sources":["webpack://./src/screens/StudentHome.css"],"names":[],"mappings":"AAAA,0EAA0E;;AAE1E;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,qBAAqB;EACrB,gCAAgC;EAChC,iBAAiB;EACjB,oBAAoB;EACpB,oCAAoC;EACpC,kBAAkB;EAClB,wCAAwC;EACxC,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,oBAAoB;AACtB;;AAEA,6DAA6D;AAC7D;EACE,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,wBAAwB;EACxB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA,kEAAkE;AAClE;EACE,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,gBAAgB;EAChB;;;;8BAI4B;AAC9B;;AAEA;EACE,WAAW;EACX,wCAAwC;EACxC,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,yCAAyC;EACzC,qBAAqB;EACrB,6BAA6B;EAC7B,2CAA2C;EAC3C,6CAA6C;AAC/C;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,wCAAwC;EACxC,YAAY;EACZ,WAAW;EACX,cAAc;EACd,iDAAiD;AACnD;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,8BAA8B;EAC9B,uBAAuB;EACvB;;;oBAGkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,uBAAuB;EACvB,0CAA0C;AAC5C;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE;IACE,wBAAwB;IACxB,wBAAwB;IACxB,0BAA0B;IAC1B,kCAAkC;IAClC,wCAAwC;IACxC,8CAA8C;EAChD;;EAEA;IACE,iCAAiC;IACjC,uCAAuC;IACvC,2CAA2C;IAC3C,2BAA2B;IAC3B,mCAAmC;EACrC;;EAEA;IACE,oBAAoB;EACtB;;EAEA;;IAEE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,+BAA+B;EAC/B,2BAA2B;EAC3B,6BAA6B;EAC7B,kCAAkC;EAClC,+BAA+B;EAC/B,gBAAgB;EAChB,gCAAgC;EAChC;;;;;;mBAMiB;AACnB;;AAEA,2EAA2E;AAC3E;EACE,mBAAmB;EACnB,kCAAkC;EAClC,6BAA6B;EAC7B,2BAA2B;EAC3B,sBAAsB;EACtB,4BAA4B;EAC5B,yBAAyB;EACzB,2BAA2B;EAC3B,uBAAuB;EACvB,yBAAyB;EACzB,0CAA0C;AAC5C;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,YAAY;EACZ,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE;IACE,WAAW;EACb;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,6BAA6B;EAC/B;AACF;;AAEA;EACE,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA,+CAA+C;AAC/C,4EAA4E;AAC5E;EACE,WAAW;EACX,aAAa;EACb,cAAc;EACd,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,cAAc;EACd;oEACkE;EAClE,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,uEAAuE;EACvE,yBAAyB;EACzB,6EAA6E;AAC/E;;AAEA;EACE,UAAU;AACZ;;AAEA;;EAEE,UAAU;EACV,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,oBAAoB;EACpB,UAAU;EACV,qDAAqD;AACvD;;AAEA,2EAA2E;AAC3E;EACE,8CAA8C;EAC9C,mBAAmB;EACnB,oBAAoB;EACpB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yEAAyE;AAC3E;;AAEA;EACE;IACE,aAAa;IACb,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,gBAAgB;EAChB,4DAA4D;EAC5D;4BAC0B;EAC1B,+BAA+B;EAC/B,8BAA8B;EAC9B,8BAA8B;EAC9B,oBAAoB;EACpB,yDAAyD;AAC3D;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,8BAA8B;EAC9B,yBAAiB;UAAjB,iBAAiB;EACjB;8CAC4C;EAC5C,uCAAuC;EACvC,sFAAsF;EACtF,yBAAyB;EACzB;;iEAE+D;EAC/D,sBAAsB;AACxB;;AAEA;EACE;IACE,UAAU;IACV,sBAAsB;EACxB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,wCAAwC;EAC1C;EACA;IACE,mDAAmD;EACrD;AACF;;AAEA,6CAA6C;AAC7C;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,mBAAmB;EACnB,oEAAoE;EACpE,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;EACnB,kDAAkD;AACpD;AACA;EACE,mBAAmB;EACnB,kDAAkD;AACpD;AACA;EACE,mBAAmB;EACnB,iDAAiD;AACnD;AACA;EACE,mBAAmB;EACnB,iDAAiD;AACnD;;AAEA;EACE;IACE,0CAA0C;IAC1C,UAAU;EACZ;EACA;IACE,aAAa;EACf;EACA;IACE,+CAA+C;IAC/C,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,kDAAkD;IAClD,UAAU;EACZ;AACF;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV;;;;;;;;;;;;KAYG;EACH,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB;2BACyB;EACzB,oBAAoB;EACpB,oCAAoC;EACpC,iDAAiD;EACjD;;;;;oCAKkC;EAClC,+BAA+B;EAC/B,+BAA+B;EAC/B,yDAAyD;AAC3D;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,sCAAsC;EACtC,uBAAuB;EACvB,iBAAiB;EACjB,yBAAyB;EACzB,4CAA4C;EAC5C,UAAU;EACV,mCAAmC;EACnC;YACU;AACZ;;AAEA;EACE;IACE,UAAU;IACV,sBAAsB;IACtB,2BAA2B;IAC3B,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;IACE,UAAU;IACV,uBAAuB;IACvB,wBAAwB;IACxB,eAAe;EACjB;AACF;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,wCAAwC;EACxC,qBAAqB;EACrB,iBAAiB;EACjB,yBAAyB;EACzB,gCAAgC;EAChC,0CAA0C;EAC1C,UAAU;EACV;YACU;AACZ;;AAEA;EACE,kBAAkB;EAClB,sCAAsC;EACtC,uBAAuB;EACvB,gBAAgB;EAChB,wCAAwC;EACxC,sBAAsB;EACtB,yBAAyB;EACzB,+BAA+B;EAC/B,UAAU;EACV;YACU;AACZ;;AAEA,6CAA6C;AAC7C;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,oDAAoD;EACpD,qCAAqC;EACrC,wBAAwB;EACxB;YACU;AACZ;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,wCAAwC;EACxC,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,oBAAoB;EACpB,oCAAoC;EACpC,yBAAyB;EACzB,uBAAuB;EACvB,+BAA+B;EAC/B,eAAe;EACf,mCAAmC;EACnC,2BAA2B;EAC3B,qBAAqB;EACrB,2CAA2C;EAC3C,0EAA0E;EAC1E,UAAU;EACV;YACU;AACZ;;AAEA,6CAA6C;AAC7C;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,sBAAsB;EACtB,qCAAqC;EACrC;YACU;EACV,oBAAoB;AACtB;;AAEA;EACE;IACE,mBAAmB;IACnB,YAAY;EACd;EACA;;IAEE,2BAA2B;IAC3B,UAAU;EACZ;AACF;;AAEA;EACE,wBAAwB;EACxB,2BAA2B;EAC3B,2CAA2C;EAC3C,+BAA+B;AACjC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,8EAA8E;EAC9E,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,sCAAsC;EACtC,UAAU;EACV,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;EACpB,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;EACrB,uBAAuB;EACvB,kCAAkC;EAClC,sBAAsB;EACtB,6BAA6B;EAC7B,2BAA2B;EAC3B,qBAAqB;EACrB,yBAAyB;EACzB,eAAe;EACf,oBAAoB;EACpB,2BAA2B;EAC3B,iDAAiD;EACjD,2CAA2C;EAC3C,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,8CAA8C;EAC9C,oBAAoB;EACpB,sBAAsB;EACtB,kBAAkB;EAClB,wDAAwD;AAC1D;;AAEA;;;EAGE,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;;IAEE,wBAAwB;EAC1B;EACA;IACE,0BAA0B;EAC5B;AACF;;AAEA,8CAA8C;AAC9C;EACE,kBAAkB;EAClB,UAAU;EACV,wBAAwB;EACxB,4BAA4B;EAC5B,+CAA+C;EAC/C,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,wBAAwB;AACxB;;;;;;;;;EASE,UAAU;EACV,2BAA2B;EAC3B;;iDAE+C;AACjD;;AAEA;;;;;;;;;EASE,UAAU;EACV,wBAAwB;AAC1B;;AAEA,mBAAmB;AACnB;EACE,uBAAuB;AACzB;AACA;EACE,uBAAuB;AACzB;AACA;;EAEE,sBAAsB;AACxB;;AAEA,0BAA0B;AAC1B;;;;EAIE,uBAAuB;AACzB;AACA;;;;EAIE,uBAAuB;AACzB;AACA;;;;EAIE,uBAAuB;AACzB;AACA;;;EAGE,uBAAuB;AACzB;AACA;;EAEE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE;;IAEE,uBAAuB;IACvB,0BAA0B;IAC1B,2BAA2B;EAC7B;;EAEA;IACE,0BAA0B;IAC1B,0BAA0B;EAC5B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;;;;IAKE,0BAA0B;IAC1B,UAAU;IACV,0BAA0B;IAC1B,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;IAC1B,gDAAgD;EAClD;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;;;;;;;;;IAUE,qBAAqB;IACrB,0BAA0B;IAC1B,2BAA2B;EAC7B;;EAEA;IACE,+BAA+B;IAC/B,2BAA2B;EAC7B;AACF;;AAEA,+BAA+B;AAC/B;EACE,WAAW;EACX,gDAAgD;AAClD;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,uBAAuB;EACvB,gBAAgB;EAChB,yCAAyC;EACzC,uBAAuB;EACvB,iBAAiB;EACjB,oBAAoB;EACpB,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,cAAc;EACd,WAAW;EACX,yBAAyB;EACzB,oBAAoB;EACpB,6BAA6B;EAC7B,8DAA8D;AAChE;;AAEA;EACE,SAAS;EACT,qCAAqC;EACrC,wBAAwB;AAC1B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,yCAAyC;EACzC,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA,yBAAyB;AACzB;EACE,yCAAyC;EACzC,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,mCAAmC;AACrC;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,oCAAoC;EACpC,mBAAmB;EACnB,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,uCAAuC;EACvC,2CAA2C;EAC3C,0CAA0C;EAC1C,wCAAwC;EACxC,6CAA6C;EAC7C,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B;;;2BAGyB;AAC3B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,SAAS;EACT,UAAU;EACV,iCAAiC;AACnC;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;EAC/C,6CAA6C;AAC/C;;AAEA;EACE,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,iCAAiC;EACjC,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,kDAAkD;AACpD;;AAEA;EACE,UAAU;EACV,0BAA0B;AAC5B;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA,mBAAmB;AACnB;EACE,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,cAAc;EACd,sBAAsB;AACxB;;AAEA;;;EAGE,WAAW;AACb;;AAEA;EACE,SAAS;EACT,eAAe;EACf,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,+BAA+B;EAC/B,gCAAgC;EAChC,6BAA6B;EAC7B,8CAA8C;EAC9C;;kDAEgD;AAClD;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,sCAAsC;EACtC,sBAAsB;AACxB;;AAEA,mDAAmD;AACnD;;EAEE,0BAA0B;EAC1B,QAAQ;AACV;;AAEA;EACE,0DAA0D;EAC1D,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA,oBAAoB;AACpB;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,6BAA6B;EAC7B,gCAAgC;EAChC,+BAA+B;EAC/B,6CAA6C;EAC7C;;kDAEgD;AAClD;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA,8DAA8D;AAC9D;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAO;EACP,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;EACZ,YAAY;EACZ,kCAAkC;AACpC;;AAEA;EACE,SAAS;EACT,8BAA8B;EAC9B,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,uCAAuC;EACvC,2CAA2C;EAC3C,gBAAgB;EAChB,4EAA4E;EAC5E,wBAAwB;EACxB,oBAAoB;EACpB,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,8BAA8B;EAC9B,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;EACvB,2CAA2C;EAC3C,wCAAwC;EACxC,+BAA+B;EAC/B,2BAA2B;EAC3B,4BAA4B;EAC5B,+BAA+B;EAC/B,eAAe;EACf;;;uBAGqB;AACvB;;AAEA;EACE,sCAAsC;EACtC,+CAA+C;EAC/C,2BAA2B;AAC7B;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA,gBAAgB;AAChB;EACE,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;EACnB,sCAAsC;EACtC,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,gCAAgC;AAClC;;AAEA;EACE,+BAA+B;EAC/B,6BAA6B;EAC7B,gCAAgC;EAChC,+BAA+B;EAC/B,6CAA6C;EAC7C,0DAA0D;AAC5D;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA,kBAAkB;AAClB;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,0DAA0D;EAC1D,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,qCAAqC;EACrC,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,oCAAoC;EACpC,mDAAmD;AACrD;;AAEA;EACE,oBAAoB;EACpB,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,eAAe;EACf,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,qBAAqB;EACrB,iDAAiD;AACnD;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,SAAS;EACT,+BAA+B;EAC/B,mBAAmB;EACnB,8CAA8C;EAC9C,gCAAgC;AAClC;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,iBAAiB;IACjB,aAAa;EACf;AACF;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;EAChC,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,aAAa;EACb,oCAAoC;EACpC,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,SAAS;AACX;;AAEA,wBAAwB;AACxB;EACE;IACE,4BAA4B;EAC9B;;EAEA;IACE,oBAAoB;IACpB,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,uBAAuB;EACzB;AACF","sourcesContent":["/* Student / guest landing tokens on :root so portaled hero can use them */\n\n:root {\n  --sh-bg: #fbfbfd;\n  --sh-ink: #1f1b2e;\n  --sh-muted: #55515f;\n  --sh-pink: #f2c4c4;\n  --sh-peach: #f9e1be;\n  --sh-mint: #bff1db;\n  --sh-lavender: #d5d1fd;\n  --sh-panel: #f4f2f8;\n  --sh-surface: #ffffff;\n  --sh-line: rgba(31, 27, 46, 0.1);\n  --sh-radius: 20px;\n  --sh-radius-sm: 14px;\n  /* ~5% breathing room on each side */\n  --sh-section-x: 5%;\n  --sh-section-y: clamp(3rem, 7vh, 5.5rem);\n  --sh-max: 100%;\n  --hero-progress: 0;\n  --hero-scale: 1.02;\n  --hero-content-opacity: 1;\n  --hero-content-scale: 1;\n  --hero-blur: 0px;\n}\n\n.student-landing {\n  background: var(--sh-bg);\n  color: var(--sh-ink);\n}\n\n/* Kill rubber-band bounce when the content sheet is active */\nbody.student-landing-mode-content {\n  overscroll-behavior-y: none;\n}\n\nbody.student-landing-mode-content .student-hero-stage {\n  height: 0 !important;\n  min-height: 0 !important;\n  max-height: 0 !important;\n  overflow: hidden;\n}\n\n/* â€”â€” Navbar: submerged in hero, solidifies on scroll â€”â€” */\n.student-landing .student-nav-spacer {\n  margin-bottom: 0;\n  height: 0;\n}\n\n.student-landing .student-nav {\n  z-index: 50;\n  height: 72px;\n  border-bottom: 1px solid transparent;\n  box-shadow: none;\n  transition:\n    background-color 0.35s ease,\n    border-color 0.35s ease,\n    box-shadow 0.35s ease,\n    backdrop-filter 0.35s ease;\n}\n\n.student-landing .student-nav--overlay {\n  top: 0.9rem;\n  background-color: transparent !important;\n  backdrop-filter: none;\n  -webkit-backdrop-filter: none;\n}\n\n.student-landing .student-nav--solid {\n  background-color: var(--sh-bg) !important;\n  backdrop-filter: none;\n  -webkit-backdrop-filter: none;\n  border-bottom-color: rgba(48, 45, 69, 0.08);\n  box-shadow: 0 8px 28px rgba(48, 45, 69, 0.08);\n}\n\n.student-landing .student-nav .navbar-brand {\n  padding: 0;\n}\n\n.student-landing .student-nav .student-nav__logo {\n  margin-left: clamp(0.75rem, 2vw, 1.5rem);\n  height: 34px;\n  width: auto;\n  display: block;\n  transition: filter 0.35s ease, opacity 0.35s ease;\n}\n\n.student-landing .student-nav--overlay .student-nav__logo {\n  filter: brightness(0) invert(1);\n}\n\n.student-landing .student-nav--solid .student-nav__logo {\n  filter: none;\n}\n\n.student-landing .student-nav .navbar-toggler {\n  margin-right: 0.75rem;\n  border-radius: 12px !important;\n  padding: 0.4rem 0.55rem;\n  transition:\n    background-color 0.3s ease,\n    border-color 0.3s ease,\n    filter 0.3s ease;\n}\n\n.student-landing .student-nav--overlay .navbar-toggler {\n  background: #fff !important;\n  border: none !important;\n  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.22);\n}\n\n.student-landing .student-nav--overlay .navbar-toggler-icon {\n  filter: none;\n}\n\n.student-landing .student-nav .navbar-collapse {\n  margin-right: clamp(0.5rem, 2vw, 1.5rem);\n}\n\n.student-landing .student-nav .navbar-nav {\n  align-items: center;\n  gap: 0.45rem;\n  padding: 0.75rem 0;\n}\n\n.student-landing .student-nav--overlay .navbar-nav {\n  gap: 0.55rem;\n}\n\n@media (max-width: 991.98px) {\n  .student-landing .student-nav .navbar-collapse {\n    background: var(--sh-bg);\n    margin: 0.5rem 0.75rem 0;\n    padding: 0.75rem 1rem 1rem;\n    border-radius: var(--sh-radius-sm);\n    border: 1px solid rgba(48, 45, 69, 0.08);\n    box-shadow: 0 10px 28px rgba(48, 45, 69, 0.12);\n  }\n\n  .student-landing .student-nav--overlay .navbar-collapse {\n    background: rgba(18, 16, 26, 0.9);\n    border-color: rgba(255, 255, 255, 0.12);\n    box-shadow: 0 14px 36px rgba(0, 0, 0, 0.35);\n    backdrop-filter: blur(16px);\n    -webkit-backdrop-filter: blur(16px);\n  }\n\n  .student-landing .student-nav .navbar-nav {\n    align-items: stretch;\n  }\n\n  .student-landing .student-nav .nav-item,\n  .student-landing .student-nav .dropdown {\n    width: 100%;\n  }\n\n  .student-landing .student-nav .btn {\n    width: 100%;\n    margin: 0.25rem 0 !important;\n  }\n}\n\n@media (min-width: 992px) {\n  .student-landing .student-nav .navbar-nav {\n    padding: 0;\n  }\n}\n\n.student-landing .student-nav .btn {\n  display: inline-flex !important;\n  align-items: center;\n  justify-content: center;\n  line-height: 1.2;\n  border-radius: 999px !important;\n  font-weight: 700 !important;\n  font-size: 0.85rem !important;\n  padding: 0.45rem 1.1rem !important;\n  color: var(--sh-ink) !important;\n  box-shadow: none;\n  text-decoration: none !important;\n  transition:\n    transform 0.15s ease,\n    filter 0.15s ease,\n    box-shadow 0.3s ease,\n    background-color 0.3s ease,\n    border-color 0.3s ease,\n    color 0.3s ease;\n}\n\n/* Hero overlay only: same white chips, labels easier to read at a glance */\n.student-landing .student-nav--overlay .btn {\n  min-height: 3.15rem;\n  padding: 0.7rem 1.65rem !important;\n  font-size: 1.18rem !important;\n  font-weight: 800 !important;\n  letter-spacing: 0.06em;\n  line-height: 1.15 !important;\n  text-transform: uppercase;\n  background: #fff !important;\n  border: none !important;\n  color: #14121c !important;\n  box-shadow: 0 10px 28px rgba(0, 0, 0, 0.3);\n}\n\n.student-landing .student-nav--overlay .btn:hover {\n  background: #fff !important;\n  color: #14121c !important;\n  filter: none;\n  transform: translateY(-2px);\n  box-shadow: 0 14px 34px rgba(0, 0, 0, 0.36);\n}\n\n@media (min-width: 992px) {\n  .student-landing .student-nav--overlay {\n    top: 1.1rem;\n  }\n\n  .student-landing .student-nav--overlay .navbar-nav {\n    gap: 0.75rem;\n  }\n\n  .student-landing .student-nav--overlay .btn {\n    font-size: 1.22rem !important;\n  }\n}\n\n.student-landing .student-nav--solid .btn:hover {\n  filter: brightness(0.97);\n  transform: translateY(-1px);\n}\n\n/* â€”â€” Immersive full-viewport hero â€”â€” */\n/* Stage = document spacer only. Hero paints fixed over the real viewport. */\n.student-hero-stage {\n  width: 100%;\n  height: 100vh;\n  height: 100svh;\n  height: 100dvh;\n  pointer-events: none;\n}\n\n.student-hero {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  height: 100dvh;\n  /* Above body at rest so spacer mismatch never reveals white content.\n     Drops under the content sheet once the user starts scrolling. */\n  z-index: 3;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  overflow: hidden;\n  color: #fff;\n  /* Dimmed teal matching the photo so there's no flash before it loads */\n  background-color: #4f6f78;\n  /* Do not transform this layer â€” transforms break fixed viewport coverage */\n}\n\nbody.student-landing-scrolled .student-hero {\n  z-index: 1;\n}\n\nbody.student-landing-hero-done .student-hero,\nbody.student-landing-mode-content .student-hero {\n  opacity: 0;\n  visibility: hidden;\n  pointer-events: none;\n}\n\nbody.student-landing-mode-hero .student-hero {\n  opacity: 1;\n  visibility: visible;\n  pointer-events: auto;\n  z-index: 3;\n  transition: opacity 0.28s ease, visibility 0.28s ease;\n}\n\n/* Explore → content: keep hero visible while progress/blur/stage animate */\nbody.student-landing-hero-exiting .student-hero {\n  opacity: calc(1 - var(--hero-progress) * 1.05);\n  visibility: visible;\n  pointer-events: none;\n  z-index: 3;\n  transition: none;\n}\n\nbody.student-landing-hero-exiting .student-hero__media {\n  transition: none;\n}\n\nbody.student-landing-hero-exiting .student-landing__body {\n  animation: student-content-rise 0.78s cubic-bezier(0.22, 1, 0.36, 1) both;\n}\n\n@keyframes student-content-rise {\n  from {\n    opacity: 0.35;\n    transform: translateY(28px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  body.student-landing-hero-exiting .student-landing__body {\n    animation: none;\n  }\n}\n\n.student-hero__media {\n  position: absolute;\n  inset: -1.5%;\n  z-index: 0;\n  overflow: hidden;\n  /* Cursor parallax (set by MainImageHeader) + scroll scale */\n  transform: translate3d(var(--hero-mx, 0px), var(--hero-my, 0px), 0)\n    scale(var(--hero-scale));\n  transform-origin: center center;\n  filter: blur(var(--hero-blur));\n  will-change: transform, filter;\n  pointer-events: none;\n  transition: transform 0.9s cubic-bezier(0.2, 0.8, 0.2, 1);\n}\n\n.student-hero__art {\n  position: absolute;\n  inset: 0;\n  display: block;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  object-position: center center;\n  user-select: none;\n  /* Original brand art ran at brightness(30%); keep the scene readable\n     but dim enough for white headline copy. */\n  filter: brightness(0.56) saturate(1.08);\n  /* Slow cinematic drift â€” Ken Burns (kept subtle so the full scene stays in frame) */\n  transform-origin: 50% 55%;\n  animation:\n    student-hero-art-in 1.6s cubic-bezier(0.22, 1, 0.36, 1) both,\n    student-hero-kenburns 28s ease-in-out 1.2s infinite alternate;\n  will-change: transform;\n}\n\n@keyframes student-hero-art-in {\n  from {\n    opacity: 0;\n    transform: scale(1.06);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n@keyframes student-hero-kenburns {\n  0% {\n    transform: scale(1) translate3d(0, 0, 0);\n  }\n  100% {\n    transform: scale(1.055) translate3d(-0.6%, 0.5%, 0);\n  }\n}\n\n/* Ambient pastel particles drifting upward */\n.student-hero__particles {\n  position: absolute;\n  inset: 0;\n  z-index: 1;\n  overflow: hidden;\n  pointer-events: none;\n}\n\n.student-hero__particle {\n  position: absolute;\n  left: var(--px);\n  top: var(--py);\n  width: var(--ps);\n  height: var(--ps);\n  border-radius: 50%;\n  opacity: 0;\n  filter: blur(0.6px);\n  animation: student-hero-particle var(--pt) linear var(--pd) infinite;\n  will-change: transform, opacity;\n}\n\n.student-hero__particle--mint {\n  background: #bff1db;\n  box-shadow: 0 0 14px 2px rgba(191, 241, 219, 0.55);\n}\n.student-hero__particle--lavender {\n  background: #d5d1fd;\n  box-shadow: 0 0 14px 2px rgba(213, 209, 253, 0.55);\n}\n.student-hero__particle--peach {\n  background: #f9e1be;\n  box-shadow: 0 0 14px 2px rgba(249, 225, 190, 0.5);\n}\n.student-hero__particle--pink {\n  background: #f2c4c4;\n  box-shadow: 0 0 14px 2px rgba(242, 196, 196, 0.5);\n}\n\n@keyframes student-hero-particle {\n  0% {\n    transform: translate3d(0, 0, 0) scale(0.6);\n    opacity: 0;\n  }\n  12% {\n    opacity: 0.55;\n  }\n  50% {\n    transform: translate3d(14px, -45vh, 0) scale(1);\n    opacity: 0.7;\n  }\n  88% {\n    opacity: 0.35;\n  }\n  100% {\n    transform: translate3d(-10px, -92vh, 0) scale(0.7);\n    opacity: 0;\n  }\n}\n\n.student-hero__overlay {\n  position: absolute;\n  inset: 0;\n  z-index: 1;\n  background:\n    radial-gradient(\n      ellipse 70% 60% at 50% 48%,\n      rgba(10, 18, 26, 0.42) 0%,\n      rgba(10, 18, 26, 0.12) 60%,\n      rgba(10, 18, 26, 0) 100%\n    ),\n    linear-gradient(\n      180deg,\n      rgba(10, 18, 26, 0.3) 0%,\n      rgba(10, 18, 26, 0.08) 45%,\n      rgba(10, 18, 26, 0.42) 100%\n    );\n  pointer-events: none;\n}\n\n.student-hero__content {\n  position: relative;\n  z-index: 2;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  width: min(100%, 920px);\n  padding: clamp(5rem, 14vh, 8rem) var(--sh-section-x)\n    clamp(6rem, 14vh, 8rem);\n  pointer-events: auto;\n  opacity: var(--hero-content-opacity);\n  /* Counter-parallax against the image for depth */\n  transform: translate3d(\n      calc(var(--hero-mx, 0px) * -0.35),\n      calc(var(--hero-progress) * -6vh + var(--hero-my, 0px) * -0.35),\n      0\n    )\n    scale(var(--hero-content-scale));\n  transform-origin: center center;\n  will-change: transform, opacity;\n  transition: transform 0.9s cubic-bezier(0.2, 0.8, 0.2, 1);\n}\n\n.student-hero__brand {\n  margin: 0;\n  font-weight: 800;\n  font-size: clamp(2.55rem, 8.5vw, 5rem);\n  letter-spacing: 0.045em;\n  line-height: 1.02;\n  text-transform: uppercase;\n  text-shadow: 0 10px 40px rgba(0, 0, 0, 0.35);\n  opacity: 0;\n  /* Cinematic tracking-in entrance */\n  animation: student-hero-brand-in 1.2s cubic-bezier(0.22, 1, 0.36, 1) 0.2s\n    forwards;\n}\n\n@keyframes student-hero-brand-in {\n  0% {\n    opacity: 0;\n    letter-spacing: 0.22em;\n    transform: translateY(26px);\n    filter: blur(6px);\n  }\n  60% {\n    filter: blur(0);\n  }\n  100% {\n    opacity: 1;\n    letter-spacing: 0.045em;\n    transform: translateY(0);\n    filter: blur(0);\n  }\n}\n\n.student-hero__headline {\n  margin: 0.4rem 0 0;\n  font-weight: 700;\n  font-size: clamp(1.35rem, 4.2vw, 2.4rem);\n  letter-spacing: 0.1em;\n  line-height: 1.15;\n  text-transform: uppercase;\n  color: rgba(255, 255, 255, 0.94);\n  text-shadow: 0 8px 30px rgba(0, 0, 0, 0.3);\n  opacity: 0;\n  animation: student-hero-fade-up 0.85s cubic-bezier(0.22, 1, 0.36, 1) 0.28s\n    forwards;\n}\n\n.student-hero__tagline {\n  position: relative;\n  margin: clamp(1rem, 2.5vh, 1.5rem) 0 0;\n  padding-bottom: 0.85rem;\n  font-weight: 600;\n  font-size: clamp(0.95rem, 2.2vw, 1.2rem);\n  letter-spacing: 0.16em;\n  text-transform: uppercase;\n  color: rgba(255, 255, 255, 0.8);\n  opacity: 0;\n  animation: student-hero-fade-up 0.85s cubic-bezier(0.22, 1, 0.36, 1) 0.5s\n    forwards;\n}\n\n/* Accent rule draws in beneath the tagline */\n.student-hero__tagline::after {\n  content: \"\";\n  position: absolute;\n  left: 50%;\n  bottom: 0;\n  width: 64px;\n  height: 2px;\n  border-radius: 2px;\n  background: linear-gradient(90deg, #bff1db, #d5d1fd);\n  transform: translateX(-50%) scaleX(0);\n  transform-origin: center;\n  animation: student-hero-rule-in 0.9s cubic-bezier(0.22, 1, 0.36, 1) 1.05s\n    forwards;\n}\n\n@keyframes student-hero-rule-in {\n  to {\n    transform: translateX(-50%) scaleX(1);\n  }\n}\n\n.student-hero__cta {\n  position: relative;\n  isolation: isolate;\n  margin-top: clamp(1.5rem, 3.5vh, 2.1rem);\n  display: inline-flex;\n  align-items: center;\n  gap: 0.65rem;\n  padding: 0.9rem 2rem;\n  background-color: #bff1db !important;\n  color: #1f1b2e !important;\n  border: none !important;\n  border-radius: 999px !important;\n  cursor: pointer;\n  font-size: clamp(1rem, 2vw, 1.2rem);\n  font-weight: 800 !important;\n  text-decoration: none;\n  box-shadow: 0 12px 36px rgba(0, 0, 0, 0.28);\n  transition: transform 0.18s ease, filter 0.18s ease, box-shadow 0.18s ease;\n  opacity: 0;\n  animation: student-hero-fade-up 0.85s cubic-bezier(0.22, 1, 0.36, 1) 0.7s\n    forwards;\n}\n\n/* Soft expanding pulse ring behind the CTA */\n.student-hero__cta::before {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  z-index: -1;\n  border-radius: inherit;\n  background: rgba(191, 241, 219, 0.55);\n  animation: student-hero-pulse 3.2s cubic-bezier(0.2, 0.6, 0.3, 1) 1.8s\n    infinite;\n  pointer-events: none;\n}\n\n@keyframes student-hero-pulse {\n  0% {\n    transform: scale(1);\n    opacity: 0.6;\n  }\n  55%,\n  100% {\n    transform: scale(1.32, 1.6);\n    opacity: 0;\n  }\n}\n\n.student-hero__cta:hover {\n  filter: brightness(1.03);\n  transform: translateY(-2px);\n  box-shadow: 0 16px 40px rgba(0, 0, 0, 0.32);\n  color: var(--sh-ink) !important;\n}\n\n.student-hero__cta:active {\n  transform: translateY(0);\n}\n\n.student-hero__scroll {\n  /* Center without translateX â€” avoids jump when global :active scale fires */\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: clamp(1.25rem, 3.5vh, 2.25rem);\n  z-index: 3;\n  width: max-content;\n  margin-left: auto;\n  margin-right: auto;\n  display: inline-flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.55rem;\n  padding: 0.55rem 1rem;\n  border: none !important;\n  background: transparent !important;\n  color: #fff !important;\n  font-size: 0.92rem !important;\n  font-weight: 800 !important;\n  letter-spacing: 0.2em;\n  text-transform: uppercase;\n  cursor: pointer;\n  pointer-events: auto;\n  border-radius: 0 !important;\n  opacity: calc(var(--hero-content-opacity) * 0.95);\n  text-shadow: 0 2px 14px rgba(0, 0, 0, 0.45);\n  transition: opacity 0.2s ease;\n}\n\n.student-hero__scroll:active {\n  transform: none !important;\n  box-shadow: none !important;\n}\n\n.student-hero__scroll-label {\n  color: #fff !important;\n  font-size: 1rem;\n  font-weight: 800;\n  letter-spacing: 0.2em;\n}\n\n.student-hero__scroll-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 2.75rem;\n  height: 2.75rem;\n  border: 1.75px solid rgba(255, 255, 255, 0.65);\n  border-radius: 999px;\n  color: #fff !important;\n  font-size: 1.15rem;\n  animation: student-hero-bounce 1.6s ease-in-out infinite;\n}\n\n.student-hero__scroll:hover,\n.student-hero__scroll:hover .student-hero__scroll-label,\n.student-hero__scroll:hover .student-hero__scroll-icon {\n  color: #fff !important;\n  opacity: 1;\n}\n\n@keyframes student-hero-fade-up {\n  from {\n    opacity: 0;\n    transform: translateY(22px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes student-hero-bounce {\n  0%,\n  100% {\n    transform: translateY(0);\n  }\n  50% {\n    transform: translateY(8px);\n  }\n}\n\n/* Content sheet scrolls over the fixed hero */\n.student-landing__body {\n  position: relative;\n  z-index: 2;\n  background: var(--sh-bg);\n  border-radius: 28px 28px 0 0;\n  box-shadow: 0 -20px 50px rgba(20, 16, 32, 0.14);\n  margin-top: 0;\n  padding-top: calc(72px + 1rem);\n  overflow-x: clip;\n  overflow-y: visible;\n}\n\n/* —— Scroll reveal —— */\n.student-reveal .student-section__eyebrow,\n.student-reveal .student-section__title,\n.student-reveal .student-section__lede,\n.student-reveal .student-about__copy,\n.student-reveal .student-controls__card,\n.student-reveal .student-offerings__card,\n.student-reveal .student-about__pillar,\n.student-reveal .student-contact__item,\n.student-reveal .student-schedule__track {\n  opacity: 0;\n  transform: translateY(28px);\n  transition:\n    opacity 0.7s cubic-bezier(0.22, 1, 0.36, 1),\n    transform 0.7s cubic-bezier(0.22, 1, 0.36, 1);\n}\n\n.student-reveal.is-inview .student-section__eyebrow,\n.student-reveal.is-inview .student-section__title,\n.student-reveal.is-inview .student-section__lede,\n.student-reveal.is-inview .student-about__copy,\n.student-reveal.is-inview .student-controls__card,\n.student-reveal.is-inview .student-offerings__card,\n.student-reveal.is-inview .student-about__pillar,\n.student-reveal.is-inview .student-contact__item,\n.student-reveal.is-inview .student-schedule__track {\n  opacity: 1;\n  transform: translateY(0);\n}\n\n/* Header cascade */\n.student-reveal.is-inview .student-section__eyebrow {\n  transition-delay: 0.05s;\n}\n.student-reveal.is-inview .student-section__title {\n  transition-delay: 0.12s;\n}\n.student-reveal.is-inview .student-section__lede,\n.student-reveal.is-inview .student-about__copy {\n  transition-delay: 0.2s;\n}\n\n/* Card / pillar stagger */\n.student-reveal.is-inview .student-controls__card:nth-child(1),\n.student-reveal.is-inview .student-offerings__card:nth-child(1),\n.student-reveal.is-inview .student-about__pillar:nth-child(1),\n.student-reveal.is-inview .student-contact__item:nth-child(1) {\n  transition-delay: 0.18s;\n}\n.student-reveal.is-inview .student-controls__card:nth-child(2),\n.student-reveal.is-inview .student-offerings__card:nth-child(2),\n.student-reveal.is-inview .student-about__pillar:nth-child(2),\n.student-reveal.is-inview .student-contact__item:nth-child(2) {\n  transition-delay: 0.28s;\n}\n.student-reveal.is-inview .student-controls__card:nth-child(3),\n.student-reveal.is-inview .student-offerings__card:nth-child(3),\n.student-reveal.is-inview .student-about__pillar:nth-child(3),\n.student-reveal.is-inview .student-contact__item:nth-child(3) {\n  transition-delay: 0.38s;\n}\n.student-reveal.is-inview .student-controls__card:nth-child(4),\n.student-reveal.is-inview .student-offerings__card:nth-child(4),\n.student-reveal.is-inview .student-contact__item:nth-child(4) {\n  transition-delay: 0.48s;\n}\n.student-reveal.is-inview .student-controls__card:nth-child(n + 5),\n.student-reveal.is-inview .student-offerings__card:nth-child(n + 5) {\n  transition-delay: 0.56s;\n}\n\n.student-reveal.is-inview .student-schedule__track {\n  transition-delay: 0.22s;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .student-hero__media,\n  .student-hero__content {\n    filter: none !important;\n    transform: none !important;\n    transition: none !important;\n  }\n\n  .student-hero__art {\n    animation: none !important;\n    transform: none !important;\n  }\n\n  .student-hero__particles {\n    display: none !important;\n  }\n\n  .student-hero__brand,\n  .student-hero__headline,\n  .student-hero__tagline,\n  .student-hero__cta,\n  .student-hero__scroll-icon {\n    animation: none !important;\n    opacity: 1;\n    transform: none !important;\n    filter: none !important;\n  }\n\n  .student-hero__tagline::after {\n    animation: none !important;\n    transform: translateX(-50%) scaleX(1) !important;\n  }\n\n  .student-hero__cta::before {\n    display: none !important;\n  }\n\n  .student-reveal,\n  .student-reveal .student-section__eyebrow,\n  .student-reveal .student-section__title,\n  .student-reveal .student-section__lede,\n  .student-reveal .student-about__copy,\n  .student-reveal .student-controls__card,\n  .student-reveal .student-offerings__card,\n  .student-reveal .student-about__pillar,\n  .student-reveal .student-contact__item,\n  .student-reveal .student-schedule__track {\n    opacity: 1 !important;\n    transform: none !important;\n    transition: none !important;\n  }\n\n  .student-section__title::after {\n    transform: scaleX(1) !important;\n    transition: none !important;\n  }\n}\n\n/* —— Shared section shell —— */\n.student-section {\n  width: 100%;\n  padding: var(--sh-section-y) var(--sh-section-x);\n}\n\n.student-section__inner {\n  width: var(--sh-max);\n  max-width: 100%;\n  margin: 0 auto;\n}\n\n.student-section__header {\n  margin-bottom: clamp(1.5rem, 3vw, 2.25rem);\n  max-width: 40rem;\n}\n\n.student-section__header--center {\n  margin-left: auto;\n  margin-right: auto;\n  text-align: center;\n  max-width: 28rem;\n}\n\n.student-section__eyebrow {\n  margin: 0 0 0.45rem;\n  font-size: 0.78rem;\n  font-weight: 700;\n  letter-spacing: 0.16em;\n  text-transform: uppercase;\n  color: var(--sh-muted);\n}\n\n.student-section__title {\n  position: relative;\n  margin: 0;\n  padding-bottom: 0.75rem;\n  font-weight: 800;\n  font-size: clamp(1.75rem, 3.4vw, 2.35rem);\n  letter-spacing: -0.01em;\n  line-height: 1.15;\n  color: var(--sh-ink);\n  text-transform: none;\n}\n\n.student-section__header--center .student-section__title {\n  display: inline-block;\n}\n\n.student-section__title::after {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  bottom: 0;\n  width: 2.75rem;\n  height: 2px;\n  background: var(--sh-ink);\n  transform: scaleX(0);\n  transform-origin: left center;\n  transition: transform 0.7s cubic-bezier(0.22, 1, 0.36, 1) 0.2s;\n}\n\n.student-section__header--center .student-section__title::after {\n  left: 50%;\n  transform: translateX(-50%) scaleX(0);\n  transform-origin: center;\n}\n\n.student-reveal.is-inview .student-section__title::after {\n  transform: scaleX(1);\n}\n\n.student-reveal.is-inview .student-section__header--center .student-section__title::after {\n  transform: translateX(-50%) scaleX(1);\n}\n\n.student-section__lede {\n  margin: 0.9rem 0 0;\n  font-size: clamp(0.98rem, 1.5vw, 1.08rem);\n  line-height: 1.55;\n  color: var(--sh-muted);\n  font-weight: 500;\n}\n\n/* —— Quick controls —— */\n.student-controls {\n  padding-top: clamp(1.75rem, 4vh, 2.75rem);\n  padding-bottom: clamp(1rem, 3vh, 1.75rem);\n}\n\n.student-controls__grid {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: clamp(0.85rem, 1.8vw, 1.25rem);\n}\n\n.student-controls__card {\n  --control-accent: #d5d1fd;\n  position: relative;\n  overflow: hidden;\n  display: grid;\n  grid-template-columns: auto 1fr auto;\n  align-items: center;\n  gap: 0.9rem;\n  width: 100%;\n  min-height: 6.5rem;\n  padding: 1.15rem 1.1rem 1.15rem 1.25rem;\n  border: 1px solid var(--sh-line) !important;\n  border-radius: var(--sh-radius) !important;\n  background: var(--sh-surface) !important;\n  box-shadow: 0 8px 22px rgba(48, 45, 69, 0.05);\n  cursor: pointer;\n  text-align: left;\n  color: var(--sh-ink) !important;\n  transition:\n    transform 0.28s cubic-bezier(0.22, 1, 0.36, 1),\n    box-shadow 0.28s cubic-bezier(0.22, 1, 0.36, 1),\n    border-color 0.28s ease;\n}\n\n.student-controls__card::after {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  width: 4px;\n  background: var(--control-accent);\n}\n\n.student-reveal.is-inview .student-controls__card:hover {\n  transform: translateY(-4px);\n  border-color: rgba(31, 27, 46, 0.16) !important;\n  box-shadow: 0 16px 34px rgba(48, 45, 69, 0.1);\n}\n\n.student-controls__card:focus-visible {\n  outline: 2px solid var(--sh-ink);\n  outline-offset: 3px;\n}\n\n.student-controls__icon-wrap {\n  display: grid;\n  place-items: center;\n  width: 2.85rem;\n  height: 2.85rem;\n  border-radius: 14px;\n  background: var(--control-accent);\n  flex-shrink: 0;\n}\n\n.student-controls__icon {\n  width: 1.15rem;\n  height: 1.15rem;\n  color: var(--sh-ink);\n}\n\n.student-controls__text {\n  display: flex;\n  flex-direction: column;\n  gap: 0.28rem;\n  min-width: 0;\n}\n\n.student-controls__label {\n  margin: 0;\n  font-size: 0.86rem;\n  font-weight: 800;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: var(--sh-ink);\n}\n\n.student-controls__blurb {\n  font-size: 0.82rem;\n  line-height: 1.4;\n  font-weight: 500;\n  color: var(--sh-muted);\n}\n\n.student-controls__go {\n  display: grid;\n  place-items: center;\n  width: 1.75rem;\n  height: 1.75rem;\n  border-radius: 999px;\n  color: var(--sh-ink);\n  opacity: 0.45;\n  transition: opacity 0.2s ease, transform 0.2s ease;\n}\n\n.student-controls__card:hover .student-controls__go {\n  opacity: 1;\n  transform: translateX(2px);\n}\n\n@media (max-width: 1100px) {\n  .student-controls__grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n\n@media (max-width: 560px) {\n  .student-controls__grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n/* —— Schedule —— */\n.student-schedule {\n  background: var(--sh-panel);\n  padding-bottom: clamp(2.5rem, 6vh, 4rem);\n}\n\n.student-schedule__track {\n  width: var(--sh-max);\n  max-width: 100%;\n  margin: 0 auto;\n  box-sizing: border-box;\n}\n\n.student-schedule__track .slick-slider,\n.student-schedule__track .slick-list,\n.student-schedule__track .slick-track {\n  width: 100%;\n}\n\n.student-landing .home-schedule-carousel__loading {\n  margin: 0;\n  padding: 2rem 0;\n  color: var(--sh-muted);\n  font-weight: 600;\n}\n\n.student-landing .home-schedule-slide {\n  padding: 0 6px 8px;\n}\n\n.student-landing .home-schedule-slide__panel {\n  padding: 1rem 1rem 1.1rem;\n  max-height: none;\n  border-radius: var(--sh-radius);\n  border: 1px solid var(--sh-line);\n  background: var(--sh-surface);\n  box-shadow: 0 10px 28px rgba(48, 45, 69, 0.07);\n  transition:\n    transform 0.3s cubic-bezier(0.22, 1, 0.36, 1),\n    box-shadow 0.3s cubic-bezier(0.22, 1, 0.36, 1);\n}\n\n.student-landing .home-schedule-slide:hover .home-schedule-slide__panel {\n  transform: translateY(-4px);\n  box-shadow: 0 16px 36px rgba(48, 45, 69, 0.11);\n}\n\n.student-landing .home-schedule-slide__header {\n  gap: 0.75rem;\n  padding-bottom: 0.85rem;\n  margin-bottom: 0.85rem;\n}\n\n.student-landing .home-schedule-slide__photo.teacher-photo-frame--circle {\n  width: 96px;\n  height: 96px;\n  min-width: 96px;\n  min-height: 96px;\n  max-width: 96px;\n  max-height: 96px;\n  border-width: 3px;\n}\n\n.student-landing .home-schedule-slide__name {\n  font-size: clamp(1rem, 1.6vw, 1.15rem);\n  letter-spacing: 0.02em;\n}\n\n/* 3-up cards are narrower — keep courses stacked */\n.student-landing .home-schedule-slide__courses--split,\n.student-landing .home-schedule-slide__courses--dense {\n  grid-template-columns: 1fr;\n  gap: 8px;\n}\n\n.student-landing .home-schedule-course {\n  grid-template-columns: minmax(0, 1fr) minmax(120px, 0.9fr);\n  gap: 8px 12px;\n  padding: 11px 0;\n}\n\n.student-landing .home-schedule-course__title {\n  font-size: 1rem;\n}\n\n.student-landing .home-schedule-course__day {\n  min-width: 1.9rem;\n  padding: 3px 6px;\n  font-size: 0.7rem;\n}\n\n.student-landing .home-schedule-course__clock {\n  font-size: 0.84rem;\n}\n\n@media (max-width: 700px) {\n  .student-landing .home-schedule-slide__photo.teacher-photo-frame--circle {\n    width: 84px;\n    height: 84px;\n    min-width: 84px;\n    min-height: 84px;\n    max-width: 84px;\n    max-height: 84px;\n  }\n\n  .student-landing .home-schedule-course {\n    grid-template-columns: 1fr;\n  }\n}\n\n/* —— Offerings —— */\n.student-offerings {\n  background: var(--sh-bg);\n}\n\n.student-offerings__grid {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: clamp(1rem, 2.2vw, 1.5rem);\n}\n\n.student-offerings__card {\n  display: flex;\n  align-items: stretch;\n  gap: 1.1rem;\n  min-width: 0;\n  padding: 0.85rem;\n  background: var(--sh-surface);\n  border: 1px solid var(--sh-line);\n  border-radius: var(--sh-radius);\n  box-shadow: 0 8px 24px rgba(48, 45, 69, 0.05);\n  transition:\n    transform 0.3s cubic-bezier(0.22, 1, 0.36, 1),\n    box-shadow 0.3s cubic-bezier(0.22, 1, 0.36, 1);\n}\n\n.student-reveal.is-inview .student-offerings__card:hover {\n  transform: translateY(-4px);\n  box-shadow: 0 16px 36px rgba(48, 45, 69, 0.1);\n}\n\n/* Dimensions from TeacherPhoto (--portrait); keep flex hook */\n.student-offerings__photo {\n  flex-shrink: 0;\n}\n\n.student-offerings__body {\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  justify-content: center;\n  gap: 0.55rem;\n  min-width: 0;\n  padding: 0.35rem 0.75rem 0.35rem 0;\n}\n\n.student-offerings__caption {\n  margin: 0;\n  font-size: calc(0.72rem + 2px);\n  font-weight: 700;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n  color: var(--sh-muted);\n  line-height: 1.35;\n}\n\n.student-offerings__name {\n  margin: 0;\n  padding-bottom: 0.55rem;\n  border-bottom: 1px solid var(--sh-line);\n  font-family: \"Merriweather\", Georgia, serif;\n  font-weight: 700;\n  font-size: clamp(calc(1.2rem + 2px), calc(1.9vw + 2px), calc(1.45rem + 2px));\n  letter-spacing: -0.015em;\n  color: var(--sh-ink);\n  text-transform: none;\n  line-height: 1.25;\n  text-align: left;\n}\n\n.student-offerings__desc {\n  margin: 0;\n  font-weight: 500;\n  font-size: calc(0.95rem + 2px);\n  line-height: 1.5;\n  color: var(--sh-muted);\n  text-align: left;\n  display: -webkit-box;\n  -webkit-line-clamp: 4;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.student-offerings__toggle {\n  display: block;\n  width: max-content;\n  margin: 2rem auto 0;\n  padding: 0.65rem 1.4rem;\n  border: 1px solid var(--sh-line) !important;\n  background: var(--sh-surface) !important;\n  border-radius: 999px !important;\n  font-weight: 700 !important;\n  font-size: 0.9rem !important;\n  color: var(--sh-ink) !important;\n  cursor: pointer;\n  transition:\n    background-color 0.2s ease,\n    border-color 0.2s ease,\n    transform 0.2s ease;\n}\n\n.student-offerings__toggle:hover {\n  background: var(--sh-panel) !important;\n  border-color: rgba(31, 27, 46, 0.18) !important;\n  transform: translateY(-1px);\n}\n\n@media (max-width: 1100px) {\n  .student-offerings__grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n\n@media (max-width: 640px) {\n  .student-offerings__grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n/* —— About —— */\n.student-about {\n  background: var(--sh-panel);\n}\n\n.student-about__header {\n  max-width: 52rem;\n  margin-bottom: clamp(1.75rem, 4vw, 2.75rem);\n}\n\n.student-about__copy {\n  margin: 1rem auto 0;\n  font-size: clamp(1rem, 1.5vw, 1.08rem);\n  line-height: 1.75;\n  font-weight: 500;\n  color: var(--sh-muted);\n  text-align: left;\n}\n\n.student-section__header--center .student-about__copy {\n  text-align: center;\n}\n\n.student-about__pillars {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: clamp(0.9rem, 2vw, 1.35rem);\n}\n\n.student-about__pillar {\n  padding: 1.35rem 1.3rem 1.45rem;\n  background: var(--sh-surface);\n  border: 1px solid var(--sh-line);\n  border-radius: var(--sh-radius);\n  box-shadow: 0 8px 22px rgba(48, 45, 69, 0.04);\n  transition: transform 0.28s cubic-bezier(0.22, 1, 0.36, 1);\n}\n\n.student-about__pillar:hover {\n  transform: translateY(-3px);\n}\n\n.student-about__pillar-title {\n  margin: 0;\n  font-size: 1.05rem;\n  font-weight: 800;\n  color: var(--sh-ink);\n}\n\n.student-about__pillar-text {\n  margin: 0.55rem 0 0;\n  font-size: 0.92rem;\n  line-height: 1.55;\n  font-weight: 500;\n  color: var(--sh-muted);\n}\n\n@media (max-width: 800px) {\n  .student-about__pillars {\n    grid-template-columns: 1fr;\n  }\n\n  .student-section__header--center .student-about__copy {\n    text-align: left;\n  }\n}\n\n/* —— Contact —— */\n.student-contact {\n  background: var(--sh-bg);\n}\n\n.student-contact__layout {\n  display: grid;\n  grid-template-columns: minmax(0, 0.95fr) minmax(0, 1.05fr);\n  gap: clamp(1.75rem, 4vw, 3.5rem);\n  align-items: stretch;\n}\n\n.student-contact__info {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n\n.student-contact__intro {\n  margin: 0.85rem 0 1.5rem;\n  font-weight: 600;\n  font-size: clamp(1rem, 1.6vw, 1.1rem);\n  line-height: 1.5;\n  color: var(--sh-muted);\n}\n\n.student-contact__list {\n  display: flex;\n  flex-direction: column;\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  border-top: 1px solid var(--sh-line);\n}\n\n.student-contact__item {\n  padding: 1.15rem 0;\n  border-bottom: 1px solid var(--sh-line);\n}\n\n.student-contact__label {\n  display: block;\n  margin-bottom: 0.3rem;\n  font-weight: 800;\n  font-size: 0.75rem;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n  color: var(--sh-ink);\n}\n\n.student-contact__value {\n  margin: 0;\n  font-weight: 600;\n  font-size: 1.02rem;\n  line-height: 1.55;\n  color: var(--sh-muted);\n}\n\n.student-contact__value a {\n  color: inherit;\n  text-decoration: none;\n  border-bottom: 1px solid transparent;\n  transition: color 0.2s ease, border-color 0.2s ease;\n}\n\n.student-contact__value a:hover {\n  color: var(--sh-ink);\n  border-bottom-color: rgba(31, 27, 46, 0.35);\n}\n\n.student-contact__socials {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.65rem 1.15rem;\n  margin-top: 0.15rem;\n}\n\n.student-contact__social {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.4rem;\n  font-weight: 700;\n  font-size: 0.95rem;\n  color: var(--sh-muted);\n  text-decoration: none;\n  transition: color 0.2s ease, transform 0.15s ease;\n}\n\n.student-contact__social svg {\n  width: 1.05rem;\n  height: 1.05rem;\n  flex-shrink: 0;\n}\n\n.student-contact__social:hover {\n  color: var(--sh-ink);\n  transform: translateY(-1px);\n}\n\n.student-contact__map {\n  width: 100%;\n  min-height: 420px;\n  height: 100%;\n  border: 0;\n  border-radius: var(--sh-radius);\n  background: #eceaf0;\n  box-shadow: 0 12px 32px rgba(48, 45, 69, 0.08);\n  border: 1px solid var(--sh-line);\n}\n\n@media (max-width: 860px) {\n  .student-contact__layout {\n    grid-template-columns: 1fr;\n  }\n\n  .student-contact__map {\n    min-height: 320px;\n    height: 320px;\n  }\n}\n\n/* —— Footer —— */\n.student-landing .student-footer {\n  position: relative;\n  background: #1f1b2e;\n  color: rgba(255, 255, 255, 0.82);\n  text-align: center;\n  height: auto;\n  min-height: 4.25rem;\n  font-size: 0.85rem;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 0;\n  margin-top: 0;\n  padding: 1.35rem var(--sh-section-x);\n  opacity: 1;\n  visibility: visible;\n}\n\n.student-landing .student-footer p {\n  margin: 0;\n}\n\n/* —— Narrow phones —— */\n@media (max-width: 480px) {\n  .student-hero {\n    min-height: min(78vh, 640px);\n  }\n\n  .student-hero__content {\n    padding-top: 4.75rem;\n    padding-bottom: 3.25rem;\n  }\n\n  .student-hero__cta {\n    width: 100%;\n    max-width: 280px;\n    justify-content: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
